export default __webpack_public_path__ + "static/media/blue_pawn.12fb7f43.png";